import { getThumbnailImage } from "@/utils/media";
import { ButtonBase, CardMedia } from "@mui/material";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

type Props = {
    image: string;
    isSelected: boolean;
    onClick: (image: string) => void;
}

const Thumbnail = ({ image, isSelected, onClick }: Props) => {
    const { organizationId, templateId } = useParams<{ organizationId?: string; templateId?: string }>();

    const imageUrl = useMemo(() => {
        return getThumbnailImage({ file: image, organizationId, templateId });
    }, [image, organizationId]);

    return (
        <ButtonBase
            onClick={() => onClick(image)}
            className={`media-manager__thumbnail ${isSelected ? 'media-manager__thumbnail--selected' : ''}`}
            component="div"
        >
            <CardMedia
                component="img"
                width="100px"
                height="100px"
                image={imageUrl}
                alt={image}
            />
        </ButtonBase>
    )
}

export default Thumbnail;
